import { createAction, props } from '@ngrx/store';

export const SET_ACTIVE_CATEGORY = '[Categories] Set active Category';
export const SET_ACTIVE_CATEGORY_LISTING_PAGE =
  '[Categories] Set active Category from the listing page';

export const setActiveCategoryAction = createAction(
  SET_ACTIVE_CATEGORY,
  props<{
    categoryId?: string;
  }>(),
);

export const setActiveCategoryListingPageAction = createAction(
  SET_ACTIVE_CATEGORY_LISTING_PAGE,
  props<
    { itemCategory: string; itemCategory2: string } | Record<string, never>
  >(),
);
